import React, { useEffect, useState } from "react";

import { ReactComponent as TextSvgIcon } from "../../../../../assets/appearencePage/text.svg";
import { ReactComponent as InfoIcon } from "../../../../../assets/appearencePage/info-circle.svg";
import { ReactComponent as TextAlignLeftIconSvgIcon } from "../../../../../assets/appearencePage/textalign-left.svg";
import { ReactComponent as ImagePlceHolder } from "../../../../../assets/appearencePage/imagePlaceHolderIcon.svg";
import { ReactComponent as ImagePlceHolderDark } from "../../../../../assets/appearencePage/imagePlaceHolderIcon-dark.svg";
import { useForm } from "react-hook-form";
import { IoMdCloseCircle } from "react-icons/io";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { createSeoSettings } from "../../../../../redux/slices/appearance/createSeoSettingSlice";
import {
  gettingSettingUpdataData,
  getScreenPreviewSetting,
} from "../../../../../redux/slices/appearance/appearanceSlice";
import { useNavigate } from "react-router-dom";
import useLocales from "../../../../../hooks/useLocales";
import ExtraSmallFilledButton from "../../../../../components/common/buttons/ExtraSmallFilledButton";
import AppearanceDeleteButton from "../../../../../components/common/buttons/AppearanceDeleteButton";

const SeoAcc = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const baseUrl = process.env.REACT_APP_API_URL;
  const { translate } = useLocales();
  const schema = yup.object().shape({
    seoToggle: yup
      .boolean()
      .test(
        "true",
        translate("cms.enble_block_search_engine_indexing"),
        (val) => !!val
      )
      .required(translate("cms.enble_block_search_engine_indexing")),
    pageTitle: yup
      .string()
      .test(
        "required",
        translate("cms.page_title_required"),
        (val) => !!val.trim()
      )
      .required(translate("cms.page_title_required")),
    metaDescription: yup
      .string()
      .test(
        "required",
        translate("cms.meta_description_required"),
        (val) => !!val.trim()
      )
      .required(translate("cms.meta_description_required")),
    seoImage: yup.mixed(),
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    if (width > 768) {
      navigate("/dashboard/appearance");
    }
    const sizeHandler = () => {
      setWidth(window.innerWidth);
      if (window.innerWidth > 768) {
        navigate("/dashboard/appearance");
      }
    };
    window.addEventListener("resize", sizeHandler);
    return () => {
      window.removeEventListener("resize", sizeHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    resetField,
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),
  });

  const [subLoading, setSubLoading] = useState(false);

  const [filePreview, setFilePreview] = useState(null);

  const seoImage = watch("seoImage");

  useEffect(() => {
    if (seoImage && seoImage?.length > 0) {
      const file = seoImage[0];
      setFilePreview(URL.createObjectURL(file));
    }
  }, [seoImage]);

  const userId = JSON.parse(localStorage.getItem("user"))?.userid;
  const linkId = localStorage?.getItem("linkId");
  const user = {
    userData: userId,
    linkData: linkId,
  };

  const submitHandler = async (data) => {
    const userId = JSON.parse(localStorage.getItem("user"))?.userid;
    const pageName = JSON.parse(localStorage.getItem("user"))?.twofactor
      ?.pageName;
    const linkId = localStorage?.getItem("linkId");

    if (data?.seoToggle === true) {
      const formData = {
        metaStatus: data?.seoToggle,
        title: data?.pageTitle,
        description: data?.metaDescription,
        seoPicture: data?.seoImage?.[0],
        userId: userId,
        linkId: linkId,
      };

      setSubLoading(true);

      await dispatch(createSeoSettings(formData)).then(() => {
        dispatch(gettingSettingUpdataData(user));
        dispatch(getScreenPreviewSetting(pageName));
      });

      setSubLoading(false);
    } else {
      // toast.error("Please select Toggle")
    }
  };

  const [deleteStylePending, setDeleteStylePending] = useState(false);

  const deleteHandler = async (data) => {
    const userId = JSON.parse(localStorage.getItem("user"))?.userid;
    const pageName = JSON.parse(localStorage.getItem("user"))?.twofactor
      ?.pageName;
    const linkId = localStorage?.getItem("linkId");

    // console.log(data, "data");

    const formData = {
      metaStatus: null,
      title: null,
      description: null,
      seoPicture: null,
      userId: userId,
      linkId: linkId,
    };
    // console.log(formData, "formData");

    setDeleteStylePending(true);

    await dispatch(createSeoSettings(formData)).then(() => {
      dispatch(gettingSettingUpdataData(user));
      dispatch(getScreenPreviewSetting(pageName));
    });

    setDeleteStylePending(false);
  };

  const LinkStyls = useSelector(
    (state) => state?.gettingAppearance?.gettingAppearance?.data?.response
  );
  const [coloumValue, setColoumValue] = useState(null);

  useEffect(() => {
    LinkStyls?.map((item) => {
      if (item?.coloum_name === "seo") {
        setColoumValue({
          ...item,
          coloum_value: JSON.parse(item.coloum_value),
        });
      }
      return null;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [LinkStyls]);

  useEffect(() => {
    setValue("metaDescription", coloumValue?.coloum_value?.meta_description);
    setValue("pageTitle", coloumValue?.coloum_value?.pageTitle);
    setValue("seoToggle", coloumValue?.status);
    if (coloumValue?.coloum_value?.seo_picture) {
      setFilePreview(
        baseUrl + "/profile/" + coloumValue?.coloum_value?.seo_picture
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coloumValue]);

  return (
    <div className="mt-[20px] md:mt-[30px]">
      <form onSubmit={handleSubmit((data) => submitHandler(data))}>
        <div className="flex justify-between items-center ">
          <div className="text-small1 lg:text-body_copy2 dark:text-color_v1_dark">
            {/* Block Search Engine Indexing */}
            {translate("descriptions.block_search")}
          </div>

          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              {...register("seoToggle")}
              className="sr-only peer"
            />
            <div
              className={`w-[29px] h-[15px] bg-gray-200 dark:bg-[#404040] rounded-full peer peer-checked:after:translate-x-[13.5px] peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-[11px] after:w-[11px] after:transition-all peer-checked:bg-green-600 ${
                errors?.seoToggle
                  ? "ring-1 ring-state_color_error bg-red-300 after:bg-state_color_error"
                  : ""
              }`}
            ></div>
          </label>
        </div>
        {errors.seoToggle && (
          <small className="text-state_color_error text-small3  text-right">
            {errors?.seoToggle?.message}
          </small>
        )}
        <div className="flex mt-[4.5px] gap-[5px] items-start lg:items-center">
          <div className="flex justify-center items-center">
            <InfoIcon />
          </div>
          <div className="text-dark_bg_v5 dark:text-dark_bg_v5 text-small3 lg:text-small2">
            {/* Block your biolink page from being indexed by search engines. */}
            {translate("descriptions.block_biolink")}
          </div>
        </div>

        <div className="relative mt-[20px] md:mt-[23.5px]">
          <input
            type={"text"}
            {...register("pageTitle")}
            className={`ps-[33px] bg-light_bg_v5 border text-heading_color text-small2 md:text-small1 rounded-md  focus:outline-none block w-full p-[13px] md:p-[11px] py-[5px] md:py-[3px] md:ps-[33px] md:px-[15px] px-[15px] dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark dark:bg-dark-secondary ${
              errors?.pageTitle
                ? "border-state_color_error placeholder:text-state_color_error"
                : "border-light_bg_v2 bg-transparent focus:border-font_light_color focus:placeholder:text-heading_color dark:border-color_dark focus:dark:border-font_color"
            }`}
            placeholder={translate("cms.enter_page_title")}
          />
          <div className="absolute start-[10px] inset-y-0 flex justify-center items-center cursor-pointer">
            <TextSvgIcon
              className={`${
                errors?.pageTitle
                  ? " stroke-state_color_error"
                  : darkMode
                  ? "stroke-color_v1_dark"
                  : "stroke-heading_color"
              } `}
            />
          </div>
        </div>
        {errors.pageTitle && (
          <small className="text-state_color_error text-small3">
            {errors?.pageTitle?.message}
          </small>
        )}
        <div className="flex mt-[6.5px] gap-[5px] lg:items-center">
          <div className="flex justify-center items-center">
            <InfoIcon />
          </div>
          <div className="text-dark_bg_v5 dark:text-dark_bg_v5 text-small3 lg:hidden">
            Leave empty to have the default site branding.
          </div>
          <div className="text-dark_bg_v5 dark:text-dark_bg_v5 text-small3 hidden lg:block lg:text-small2">
            {/* Completely change the page title to a custom one that you are
          setting here. */}
            {translate("descriptions.change_page")}
          </div>
        </div>

        <div className="relative mt-[20px] lg:mt-[23.5px]">
          <textarea
            rows={width > 768 ? "1" : "4"}
            {...register("metaDescription")}
            className={`block resize-none lg:ps-[33px] ps-[39px] bg-light_bg_v5 border text-heading_color text-small2 md:text-small1 rounded-md  focus:outline-none w-full lg:p-[10px] p-[13px] lg:px-[15px] px-[16px] dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark dark:bg-dark-secondary ${
              errors?.metaDescription
                ? "border-state_color_error placeholder:text-state_color_error"
                : "border-light_bg_v2 bg-transparent focus:border-font_light_color focus:placeholder:text-heading_color dark:border-color_dark focus:dark:border-font_color"
            }`}
            placeholder={translate("cms.enter_meta_description")}
          ></textarea>

          <div className="absolute start-[16px] lg:start-[10px] inset-y-0 flex justify-center top-[13px] lg:top-[13px] cursor-pointer">
            <TextAlignLeftIconSvgIcon
              className={`${
                errors?.metaDescription
                  ? " stroke-state_color_error"
                  : darkMode
                  ? "stroke-color_v1_dark"
                  : "stroke-heading_color"
              } `}
            />
          </div>
        </div>
        {errors.metaDescription && (
          <small className="text-state_color_error text-small3">
            {errors?.metaDescription?.message}
          </small>
        )}
        <div className="flex mt-[6.5px] gap-[5px] items-start">
          <div className="flex justify-center items-center">
            <InfoIcon />
          </div>
          <div className="text-dark_bg_v5 dark:text-dark_bg_v5 text-small3 lg:text-small2">
            {/* Set a custom meta description for your biolink page to rank better
        in search engines. */}
            {translate("descriptions.custom_meta")}
          </div>
        </div>

        {filePreview ? (
          <div className="md:flex items-center mt-[22px] hidden ">
            <div className="bg-light_bg_v4  rounded-lg cursor-pointer relative">
              <div
                onClick={() => {
                  setFilePreview(null);
                  resetField("seoImage", { keepTouched: true });
                }}
                className="absolute cursor-pointer -right-2 -top-2 text-state_color_error text-lg "
              >
                <IoMdCloseCircle />
              </div>
              <img
                className="h-[60px] w-[60px] sm:h-[64px] sm:w-[64px] p-1 object-cover rounded-lg dark:bg-dark-secondary"
                src={filePreview}
                alt="..."
              />
            </div>
          </div>
        ) : (
          <div className="flex">
            <label htmlFor="seoImage" className="hidden md:block">
              <div className="flex gap-4 items-center mt-[22px]">
                <div className="bg-[#D9D9D9] dark:bg-dark-primary rounded-lg cursor-pointer">
                  {darkMode ? <ImagePlceHolderDark /> : <ImagePlceHolder />}
                </div>
                <div className=" text-main_color text-small3_b">
                  {/* INSERT GRAPH IMAGE */}
                  {translate("cms.insert_graph_image")}
                  <div className="text-[10px] mt-[5px] text-font_light_color font-normal dark:text-font_dark_color">
                    (2 MB {translate("cms.maximum")} ( .png, .gif, .ico ))
                  </div>
                </div>
              </div>
              <input
                id="seoImage"
                type="file"
                {...register("seoImage")}
                accept="image/*"
                className="hidden"
              />
            </label>
          </div>
        )}
        {errors.seoImage && (
          <small className="text-state_color_error text-small3">
            {errors?.seoImage?.message}
          </small>
        )}

        <div className="flex mt-[25px] items-center justify-end">
          <AppearanceDeleteButton
            isLoading={deleteStylePending}
            onClickHandler={deleteHandler}
          />
          {/*  <button
            type="submit"
            className={`ms-3 rounded-full flex p-1.5 px-[22px] bg-main_color text-white text-small3_b ${
              subLoading ? "opacity-70" : ""
            } `}
          >
            {subLoading ? (
              <svg
                aria-hidden="true"
                role="status"
                className="inline w-3 h-3 text-white animate-spin"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="#E5E7EB"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentColor"
                />
              </svg>
            ) : (
              "SAVE"
            )}
            </button> */}
          <ExtraSmallFilledButton
            name={`${translate("biolink_title.save_cap")}`}
            buttonType={"submit"}
            isLoading={subLoading}
            classes={"ms-3"}
          />
        </div>
      </form>
    </div>
  );
};

export default SeoAcc;
